// @flow
// eslint-env browser


/**
 * Throttle a function call
 *
 * @export
 * @param {() => void} fn
 * @param {number} [time=200]
 * @returns
 */
export function throttle(fn: () => void, time: number = 200) {
    let timeout: TimeoutID | null;
    function release() {
        timeout = null;
        fn();
    }
    function wrapper() {
        if (timeout) {
            return;
        }
        timeout = setTimeout(release, time);
    }
    return wrapper;
}
